import BaseModel from '../core/BaseModel'
export default class AppraisalModel extends BaseModel {
    constructor() {
        super({ 
                name: "appraisal",
                tableName: 'core_appraisal'
            }, 
            {
            id: { 
                name: 'id', 
                type: "String", 
                label: 'ID', 
                primaryKey: true,
                display: false
            },
            serviceCode: { 
                name: 'code', 
                type: "String", 
                label: 'Mã dịch vụ',
                sortable: true,
                width: 15,
                filter: { type: 'input',  match: 'custom'},
                computed: (data) => {
                    data.serviceCode = data.code;
                }
            },
            created_date: { 
                name: 'created_date', 
                type: "CustomDateTime", 
                label: 'Thời gian tạo',
                class: 'top-datepicker',
                sortable: true,
                width: 15,
                filter: { type: 'DateRange', match: 'custom'}
            },
            organizationRequest: { 
                name: 'organizationRequest', 
                label: 'Đơn vị yêu cầu',
                class: 'center',
                type: "Text",
                sortable: true,
                width: 15,
                filter: { type: 'input',  match: 'custom'},
                computed: (data) => {
                    var requestName = (data.request_organization != undefined && data.request_organization != null && data.request_organization.name != undefined) ? data.request_organization.name : '';
                    data.organizationRequest = requestName;
                }
            },
            organizationAppraisal: { 
                name: 'organizationAppraisal', 
                label: 'Đơn vị thẩm định',
                class: 'center',
                type: "Text",
                sortable: true,
                width: 15,
                filter: { type: 'input',  match: 'custom'},
                computed: (data) => {
                    var appraisalName = (data.appraisal_organization != undefined && data.appraisal_organization != null && data.appraisal_organization.name != undefined) ? data.appraisal_organization.name : '';
                    data.organizationAppraisal = appraisalName;
                }
            },
            processStatus: {
                name: 'processStatus', label: 'Trạng thái xử lý', type: "Selection",  dataType: 'Label',  class: 'center', width: 15,
                options: [{ value: 1, label: 'Đã xử lý'}, { value: 0, label: 'Chờ xử lý'}],
                filter: { type: 'select', display: false, optionLabel: 'label', optionKey: 'value', match: 'equals' },
                sortable: true,
                computed: (data) => {
                   data.processStatus = data.status;
                }
            },
            products: { 
                name: 'products', 
                label: 'Sản phẩm đã xử lý',
                class: 'center',
                width: 12,
                sortable: true,
                computed: (data) => {
                    var total = (data.appraisal_product_total_aggregate !== undefined && data.appraisal_product_total_aggregate !== null) ? data.appraisal_product_total_aggregate.aggregate.count  :  0;
                    var count = (data.appraisal_product_aggregate !== undefined && data.appraisal_product_aggregate !== null) ? data.appraisal_product_aggregate.aggregate.count  :  0;
                    data.products = (total - count) + '/' + total;
                }
            },
            user_id: {
                refs: 'code status appraisal_organization { name } request_organization { name } appraisal_product_aggregate(where: {current_status: {_in: [0, 1]}}) { aggregate { count } } appraisal_product_total_aggregate { aggregate { count } }',
                display: false
            }
        },)
    }

}